export default {
    buscando: false,
    items: [],
    usuarios: [],
    submodulos: [],
}